import { updatesData } from '@/mocks/homeData';

const tagStyles: Record<string, string> = {
  '突发': 'bg-red-100 text-red-700',
  '追踪': 'bg-amber-100 text-amber-700',
  '独家': 'bg-accent-100 text-accent-700',
  '深扒': 'bg-primary-100 text-primary-700',
  '盘点': 'bg-secondary-200 text-secondary-700',
  '爆料': 'bg-orange-100 text-orange-700',
};

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          最新快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">实时追踪娱乐圈最新争议动态</p>
        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300 hidden sm:block"></div>
          <div className="flex flex-col gap-4">
            {updatesData.map((item, i) => (
              <div key={i} className="flex gap-4 relative">
                <div className="hidden sm:flex flex-col items-center pt-1.5 flex-shrink-0">
                  <div className="w-[10px] h-[10px] rounded-full bg-accent-500 border-2 border-background-50 z-10"></div>
                </div>
                <div className="flex-1 bg-background-100 border border-background-200 rounded-xl p-4 hover:border-accent-300 transition-all cursor-pointer group">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagStyles[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-accent-700 transition-colors leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 mt-1.5 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}